import type { SVGProps } from "react";
export interface Collapse04DotsIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Collapse04DotsIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Collapse04DotsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.876 20v-4c0-.62.503-1.125 1.124-1.125h4l.115.006a1.125 1.125 0 0 1 0 2.239l-.115.005h-1.284l3.08 3.08.077.085a1.125 1.125 0 0 1-1.583 1.583l-.085-.078-3.08-3.079V20a1.125 1.125 0 0 1-2.25 0ZM2.205 2.204a1.125 1.125 0 0 1 1.506-.078l.084.078 3.08 3.079V4a1.125 1.125 0 0 1 2.25 0v4c0 .62-.504 1.124-1.125 1.124H4a1.125 1.125 0 0 1 0-2.25h1.284l-3.08-3.079-.077-.085a1.125 1.125 0 0 1 .078-1.505Zm9.295 9.422a.62.62 0 0 0-.125.374l.013.126a.6.6 0 0 0 .113.246zm1 .746a.6.6 0 0 0 .112-.246l.014-.126-.014-.126a.6.6 0 0 0-.112-.248zm7.705-10.167a1.125 1.125 0 1 1 1.59 1.59l-3.079 3.08H20l.115.005a1.125 1.125 0 0 1 0 2.239L20 9.124h-4A1.125 1.125 0 0 1 14.876 8V4a1.125 1.125 0 0 1 2.25 0v1.284l3.079-3.08ZM9.125 19.999a1.125 1.125 0 1 1-2.25 0v-1.283l-3.08 3.08a1.125 1.125 0 1 1-1.59-1.591l3.079-3.08H4a1.125 1.125 0 0 1 0-2.25h4c.62 0 1.125.504 1.125 1.125v4Zm4.5-8a1.624 1.624 0 0 1-3.242.166L10.376 12l.007-.166A1.625 1.625 0 0 1 12 10.375l.166.008c.82.083 1.459.775 1.459 1.617Z"
      />
    </svg>
  );
}
